'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';

import { virtualPageView } from '@/modules/google/data-layer/data-layer';

export const VirtualPageView = () => {
  const pathsHistory = useRef<string[]>([]);
  const pathName = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!pathName) {
      return;
    }

    virtualPageView(
      window.location.href,
      document.title,
      pathName,
      pathsHistory?.current?.length > 0
        ? pathsHistory.current[pathsHistory.current.length - 1]
        : ''
    );

    pathsHistory.current.push(window.location.href);
  }, [pathName, searchParams]);

  return null;
};
